/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import Page from '../../../components/Page';
import Layout from '../../../layouts';
import { setCommentSearch } from '../../../redux/slices/blog/blog.comment';
import { dispatch, useSelector } from '../../../redux/store';
import { PracticalSection } from "../../../sections/practicalExam/PracticalSection";
import { findLicenseTypesAPI, getLicenseTypeBySlugAPI } from "../../../service/gplx.licenseType.service";

PracticalExam.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function PracticalExam({ licenseType }) {
  const { metaTitle, description, metaDescription, practicalExams } = licenseType;

  function urlify(text) {
    var anchors = /<img\s[^>]*?src=(["']?)([^\s]+?)\1[^>]*?>/ig;
    var links = [];
    text.replace(anchors, function (_anchor, _quote, url) {
      links.push(url);
    });

    return links?.[0];
  }

  const imagePath = urlify(description);

  const currentItem = practicalExams?.[0] || null;
  const nextItem = practicalExams?.[1] || null;

  const { search: searchComment } = useSelector((state) => state.blogComment);

  useEffect(() => {
    dispatch(setCommentSearch({ ...searchComment, value: '', page: 0, filterBys: { itemId: licenseType.id, type: "PRACTICE" } }));
  }, [licenseType]);

  return (
    <Page title={metaTitle} description={metaDescription} imagePath={imagePath}>
      <PracticalSection licenseType={licenseType} nextItem={nextItem} currentItem={currentItem} />
    </Page >
  );
}

export async function getStaticPaths() {
  const search = { page: 0, size: 12, value: '%%', orders: [{ order: 'asc', property: 'orderNo', },], };
  const { data } = await findLicenseTypesAPI(search);

  const paths = data.map(s => ({
    params: {
      licenseType: s.slug
    }
  }));

  return {
    paths,
    fallback: 'blocking',
  };
}

export async function getStaticProps({ params }) {
  // Fetch necessary data for the blog post using params.id
  const slug = params.licenseType;

  const { code, data: licenseType } = await getLicenseTypeBySlugAPI(slug);

  if (code !== "200") {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      licenseType,
    },
  };
}